import { Component } from '@angular/core'
import { DataCheckerService, Toaster } from '@tokeet-frontend/tv3-platform'
import { FormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { DataDictService } from '@tv3/services/data-dict.service'
import { ReviewService } from '@tokeet-frontend/reviews'
import { BookingReviewBaseComponent } from '../booking-review-base'
import { ReviewVrboGuestDialogService } from '../../review-vrbo-guest-dialog/review-vrbo-guest-dialog.service'

@Component({
  selector: 'app-vrbo-booking-review',
  templateUrl: './vrbo-booking-review.component.html',
  styleUrls: ['./vrbo-booking-review.component.scss'],
})
export class VrboBookingReviewComponent extends BookingReviewBaseComponent {
  constructor(
    fb: FormBuilder,
    store: Store<any>,
    reviewService: ReviewService,
    toaster: Toaster,
    dataDictService: DataDictService,
    dataChecker: DataCheckerService,
    private reviewVrboGuestDialog: ReviewVrboGuestDialogService
  ) {
    super(fb, store, reviewService, toaster, dataDictService, dataChecker)
  }

  onReviewGuest() {
    this.reviewVrboGuestDialog.open(this.inquiry).subscribe(() => {
      this.loadReviews()
    })
  }
}
